"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tab = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

// $FlowFixMe
var useTabsStyle = (0, _makeStyles["default"])(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      boxShadow: '0 0px 20px rgba(0,0,0,.035), 0 0px 20px rgba(0,0,0,.035)'
    },
    indicator: {
      height: '5px'
    }
  };
});
var useTabStyle = (0, _makeStyles["default"])(function (_ref2) {
  var palette = _ref2.palette;
  return {
    root: {
      textTransform: 'capitalize',
      color: palette.text.disabled
    }
  };
});

var Tabs = function Tabs(_ref3) {
  var children = _ref3.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref3, ["children"]);

  var _useTabsStyle = useTabsStyle(),
      root = _useTabsStyle.root,
      indicator = _useTabsStyle.indicator;

  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], (0, _extends2["default"])({
    indicatorColor: "primary",
    textColor: "primary",
    classes: {
      root: root,
      indicator: indicator
    }
  }, rest), children);
};

var Tab = function Tab(rest) {
  var _useTabStyle = useTabStyle(),
      root = _useTabStyle.root;

  return /*#__PURE__*/_react["default"].createElement(_Tab["default"], (0, _extends2["default"])({
    disableRipple: true,
    disableFocusRipple: true,
    classes: {
      root: root
    }
  }, rest));
};

exports.Tab = Tab;
var _default = Tabs;
exports["default"] = _default;
//# sourceMappingURL=index.js.map